<template>
  <div class="footer-container">
    <!-- 网站信息模块 -->
    <div class="footer-section website-info">
      <h3 class="section-title">网站信息</h3>
      <ul class="info-list">
        <li><a href="javascript:" @click="handleContact">联系我们</a></li>
        <li><a href="javascript:" @click="handleSitemap">网站地图</a></li>
      </ul>
    </div>

    <!-- 中间跳转链接（国家平台、中央政府、江苏省府） -->
    <div class="footer-section middle-links">
      <div
          class="link-item"
          v-for="(item, index) in middleItems"
          :key="index"
      >
        <img :src="item.icon" alt="平台图标" class="link-icon" />
        <a :href="item.url" target="_blank" class="link-text">{{ item.text }}</a>
      </div>
    </div>

    <!-- 苏服办（APP/支付宝小程序/公众号 - 带二维码） -->
    <div class="footer-section sufu-links">
      <div
          class="sufu-item"
          v-for="(item, index) in sufuItems"
          :key="index"
          @click="toggleQr(index)"
      >
        <img :src="item.icon" alt="苏服办图标" class="sufu-icon" />
        <span class="sufu-text">{{ item.text }}</span>
        <!-- 点击后显示二维码 -->
        <img
            v-if="item.showQr"
            :src="item.qrCode"
            alt="二维码"
            class="qr-code-img"
        />
      </div>
    </div>

    <!-- 右侧信息（12345、找错、网站标识） -->
    <div class="footer-section right-section">
      <div class="right-item">
        <img src="@/assets/img/12345.png" alt="12345" class="right-icon" />
        <a href="https://12345.jszwfw.gov.cn/" target="_blank" rel="noopener noreferrer" class="right-text">联系12345</a>
      </div>
      <!-- 合并两个图标到一个.right-item -->
      <div class="right-item icon-group">
        <a href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=3200000098&url=https%3A%2F%2Fwww.jszwfw.gov.cn%2F" target="_blank" rel="noopener noreferrer">
          <img src="@/assets/img/zfzc.png" alt="政府网站找错" class="right-icon1" />
        </a>
        <a href="https://bszs.conac.cn/sitename?method=show&id=CB0F293AECEE5185E05310291AAC4F66" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/img/dzjg.png" alt="自定义图标" class="right-icon2" />
        </a>
      </div>
    </div>

    <!-- 底部备案/主办单位信息 -->
    <div class="footer-bottom">
      <div>主办单位：江苏省数据局（江苏省政务服务管理办公室）</div>
      <div>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">备案序号：苏ICP备15009401号</a>
      </div>
      <div>
        <a href="https://beian.mps.gov.cn/" target="_blank" rel="noopener noreferrer">公安备案号：32010602010331</a>
      </div>
      <div>网站标识：3200000098</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      // 中间跳转链接数据（国家平台、中央政府、江苏省府）
      middleItems: [
        {
          icon: require('@/assets/img/guohui.png'), // 替换为实际图标路径
          url: 'https://gjzwfw.www.gov.cn/fwmh/zwsso/signin.do?', // 国家政务服务平台真实地址
          text: '国家政务服务平台'
        },
        {
          icon: require('@/assets/img/guohui.png'),
          url: 'https://www.gov.cn/',
          text: '中华人民共和国中央人民政府'
        },
        {
          icon: require('@/assets/img/guohui.png'),
          url: 'https://www.jiangsu.gov.cn/',
          text: '江苏省人民政府网站'
        }
      ],

      // 苏服办模块数据（含二维码显示状态）
      sufuItems: [
        {
          icon: require('@/assets/img/app.png'),
          text: '苏服办APP',
          qrCode: require('@/assets/img/app.png'), // APP二维码
          showQr: false
        },
        {
          icon: require('@/assets/img/xcx.png'),
          text: '苏服办支付宝小程序',
          qrCode: require('@/assets/img/xcx.png'), // 支付宝小程序二维码
          showQr: false
        },
        {
          icon: require('@/assets/img/gzh.png'),
          text: '江苏政务服务微信公众号',
          qrCode: require('@/assets/img/gzh.png'), // 微信公众号二维码
          showQr: false
        }
      ]
    }
  },
  methods: {
    handleContact() {
      window.open('https://www.jszwfw.gov.cn/col/col173003/index.html', '_blank');
    },
    handleSitemap() {
      window.open('https://www.jszwfw.gov.cn/col/col173004/index.html', '_blank');
    },
    toggleQr(index) {
      this.sufuItems[index].showQr = !this.sufuItems[index].showQr;
    }
  }
}
</script>
<style scoped>
/* 整体容器 */
.footer-container {
  background-color: #f5f5f5;
  padding: 20px;
  font-size: 14px;
  color: #333;
  /* 新增 Flex 布局属性 */
  display: flex;          /* 开启弹性布局，子元素横向排列 */
  flex-wrap: wrap;       /* 超出父容器宽度时自动换行 */
  gap: 1rem;             /* 子模块之间的间距（替代 margin，更简洁） */
  align-items: flex-start; /* 垂直方向顶部对齐（按需调整，如居中用 center） */
}

/* 每个模块容器（灰色背景） */
.footer-section {
  background-color: #e5e5e5;
  padding: 15px;
  border-radius: 4px;
  width: 20%; /* 大屏幕下四个模块均分宽度（可根据设计调整比例） */
  min-width: 200px; /* 防止屏幕过小时宽度坍塌 */
  margin-bottom: 0; /* 移除原来的底部 margin，由父容器的 gap 控制间距 */
  /* 新增：模块内部纵向排列 */
  display: flex;
  flex-direction: column;
}

/* 模块标题 */
.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

/* 网站信息 - 列表 */
.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.info-list li {
  margin-bottom: 8px;
}
.info-list a {
  text-decoration: none;
  color: #333;
}

/* 中间跳转链接 - 图标+文字 */
.link-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.link-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.link-text {
  text-decoration: none;
  color: #333;
}

/* 苏服办 - 图标+文字+二维码 */
.sufu-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer; /* 鼠标悬浮提示“可点击” */
}
.sufu-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.sufu-text {
  margin-right: auto; /* 文字靠左，二维码靠右 */
}
.qr-code-img {
  width: 80px;
  height: 80px;
}

/* 右侧信息 - 图标+文字 */
.right-section {
  width: 23%;
}
.right-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.right-icon {
  width: 69px;
  height: 26px;
  margin-right: 8px;
}
.right-icon1 {
  width: 105px;
  height: 44px;
  margin-right: 8px;
}
.right-icon2 {
  width: 48px;
  height: 50px;
  margin-right: 8px;
}
.right-text {
  color: #333;
}

.footer-bottom {
  height: 67px;
  line-height: 67px;
  background: #EAEBEB;
  color: #333;
  font-size: 16px;
  text-align: center;

  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  div{
    margin: 0 20px;
  }
}
/* 响应式：小屏幕自动堆叠 */
@media (max-width: 768px) {
  .footer-section,
  .right-section {
    width: 48%; /* 两列布局 */
  }
}
@media (max-width: 480px) {
  .footer-section,
  .right-section {
    width: 100%; /* 单列布局 */
  }
}
</style>
